import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, [
    _createVNode("path", {
      "fill-rule": "evenodd",
      d: "M8 16a.5.5 0 010 .707l-1 1A.5.5 0 116.293 17l1-1A.5.5 0 018 16zM9.5 17.5a.5.5 0 010 .707l-1 1a.5.5 0 11-.707-.707l1-1a.5.5 0 01.707 0zM6.5 14.5a.5.5 0 010 .707l-1 1a.5.5 0 11-.707-.708l1-1a.5.5 0 01.707 0zM12.602 6.016a11.537 11.537 0 00-5.797 6.495l4.684 4.684a11.538 11.538 0 006.495-5.797l-5.382-5.382zm1.045 5.337a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z",
      "clip-rule": "evenodd"
    }),
    _createVNode("path", { d: "M18.41 10.41c.477-1.262.737-2.629.737-4.057 0-.479-.03-.95-.086-1.414a11.616 11.616 0 00-1.414-.086c-1.428 0-2.795.26-4.057.736l4.82 4.82zM12.266 17.972l1.027 1.027a.5.5 0 00.854-.353v-1.614a12.45 12.45 0 01-1.881.94zM6.028 11.734c.261-.656.576-1.285.94-1.881H5.354a.5.5 0 00-.354.854l1.028 1.027z" })
  ]))
}